
import { defineComponent } from 'vue';
import { createThreeView } from '@/components/three-model/'
import { Engine } from '@/components/three-model/engine/Engine'
import { Resource } from '@/components/three-model/engine/Resources'
import { Position } from './models/Points';

export default defineComponent({
    name: 'three-model',
    props: {
        filePath: {
            type: String,
            default: ''
        },
        position: {
            type: Object,
            required: false,
            default: () => {
                return { px: 0, py: 0, pz: 0, rx: 0, ry: 0, rz: 0, sx: 1, sy: 1, sz: 1 }
            }
        },
        points: {
            type: Array,
            required: false,
            default: () => {
                return []
            }
        },
        disable: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            width: 100,
            height: 100,
            threeInstance: null as Engine | null,
        }
    },
    watch: {
        points: {
            handler(val) {
                if (this.threeInstance && this.threeInstance.pointsExperience && this.threeInstance.pointsExperience.updateResources) {
                    const resources = this.proxyToArray(val).map((point) => {
                        return {
                            key: `${point.id}`,
                            name: point.name,
                            status: !!point.status,
                            // path: point.path || 'https://sunrainmeta.com/api/assets/cloud/b1c2410e-9e86-4971-b6a1-2004bfd9a61f.gltf',
                            path: point.path || 'https://sunrainmeta.com/api/assets/cloud/a3a0ac44-ac43-4998-872b-16b90a3c7386.gltf',
                            type: 'gltf',
                            position: point.position
                        }
                    })
                    this.threeInstance.pointsExperience?.updateResources(resources as Resource[])
                }
            },
            deep: true,
        }
    },
    mounted() {
        this.handleResize();
        const points: any[] = this.proxyToArray(this.points);
        // 调整后再开启渲染加载
        this.$nextTick(() => {
            this.threeInstance = createThreeView(this.$refs.canvasRef as HTMLCanvasElement, {
                path: this.filePath,
                position: this.position as Position,
            }, points, this.disable);
        })
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        this.threeInstance?.dispose();
        this.threeInstance = null;
    },
    methods: {
        handleResize() {
            // 处理窗口大小变化的逻辑
            const { offsetWidth, offsetHeight } = this.$refs.threeRef as HTMLElement;
            this.width = offsetWidth;
            this.height = offsetHeight;
        },
        proxyToArray(points: any[]) {
            return points.map((point: any) => {
                return {
                    id: point.id,
                    name: point.name,
                    status: point.status,
                    path: point.path,
                    position: Object.assign({ px: 0, py: 0, pz: 0, ax: 0, ay: 0, az: 0 }, point.position)
                }
            })
        }
    },
});
